import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import moment from 'moment';
import Axios from 'axios';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import has from 'lodash/has';
import getPath from 'lodash/get';
import styled from 'styled-components';
import { SoundwiseHeader } from '../../components/soundwise_header';
import BeforeUnload from '../../components/BeforeUnload';
import Payment2 from './components/payment2';
import SoundcastInCart from './components/soundcast_in_cart';
import { signinUser, signupUser } from '../../actions/index';
import { GreyInput } from '../../components/inputs/greyInput';
import { minLengthValidator } from '../../helpers/validators';
import parseQueryParams from '../../helpers/parseQueryParams';
import { hasCustomPaymentUrl } from '../../helpers/soundcasts';
import { authManager, soundcastManager, publisherManager, userManager } from '../../helpers/managers';
import SubmitButton from '../../containers/signin/SubmitButton';
import { signInPassword, signupCommon } from '../../shared_methods/common_auth';
import {
  addSoundcastToUser,
  redirectToSoundcastNoticePage,
} from '../../shared_methods/add_soundcast_to_user';
import {
  LoadingWrapper,
  FullContentWrapper,
  FullContentSection,
  FlexiRow,
} from '../../styles/styled';
import { CheckoutWrapper, CheckoutBody } from '../../styles/checkout';
import Loading from '../../components/Loading';
import { STATIC_HOMEPAGE_URL } from '../../config';
const { makePlanFromCoupon, isFreePlan } = require('../../../server/scripts/utils.js')();
import { getUserIdByEmail } from '../../helpers/userinfoHelper';

class _SoundcastCheckout2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      coupon: '',
      runSignIn: false,
      hideCardInputs: false,
      successPayment: false,

      error: '',
      processing: false,
      dirty: true,
      isTrial: false,
      totalPrice: 0,
      soundcast: null,
      soundcastID: null,
      publisher: {},
      checked: 0,
      sumTotal: '',
      isFree: false,
      renderFields: false,
      isNeedEmail: false,
      isMobileRequest: false,
    };

    this.pathname = window && window.location && (window.location.pathname || '');
    this.publisherID = moment().format('x') + 'p';
    this.handleStripeId = this.handleStripeId.bind(this);
    this.authCallback = this.authCallback.bind(this);
    this.submitPassword = this.submitPassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handlePaymentSuccess = this.handlePaymentSuccess.bind(this);
    this.handleAppliedPromo = this.handleAppliedPromo.bind(this);
    this.renderPublisherLogo = this.renderPublisherLogo.bind(this);
  }

  isCorrectLocationPathname() {
    const locationPathname = window && window.location && (window.location.pathname || '');
    return !isEmpty(locationPathname) && isEqual(locationPathname, this.pathname);
  }

  async componentDidMount() {
    await this.handleSoundcastData();
  }

  async handleSoundcastData() {
    const { history } = this.props;
    const searchParams = parseQueryParams(getPath(history, 'location.search', {}));
    let { soundcast_id: soundcastID = ''} = searchParams || {};
    if (!isEmpty(soundcastID)) {
      let {
        checked = 0,
        coupon = '',
        sumTotal = '',
        email: queryEmail = '',
        // optional
        confirmed: isConfirmed = false,
        // or
        session_id: sessionId = '',
        account_id: accountId = '',
      } = searchParams || {};
      checked = Number(checked);
      queryEmail = (queryEmail || '').toLowerCase();

      let isNeedEmail = false;
      let customerDetails = null;
      // in the future it will be necessary to use the token received from the mobile application
      // like ..&idtoken=...
      const isMobileRequest = !isEmpty(queryEmail);

      if (!isEmpty(sessionId) && !isEmpty(accountId)) {
        isConfirmed = await new Promise(async resolve => {
          try {
            const { data: reqData } = await Axios.get('/api/stripe-checkout/state', {
              params: {
                session_id: sessionId,
                account_id: accountId,
              },
            });
            const { success = false, data = null, errorMessage } = reqData || {};
            const {
              // id = null,
              customer_email,
              customer_details, 
              metadata = null,
              payment_status = null, // one of 'paid', 'unpaid', or 'no_payment_required'
              status = null, // one of 'open', 'complete', or 'expired'
            } = data || {};
            if (!success) {
              throw new Error(errorMessage);
            }
            if (!isEmpty(metadata)) {
              soundcastID = metadata.soundcastId;
              checked =  Number(metadata.checked);
              coupon = metadata.coupon;
              queryEmail = customer_email;
              customerDetails = customer_details;
            }
            if (['paid','no_payment_required'].includes(payment_status)) {
              return resolve(true);
            }
            throw new Error(`Payment has not been completed (status: ${status}, ${payment_status}). Please try again.`);
          } catch (err) {
            this.setState({
              error: err.message || 'Unknown error',
            });
          }
          resolve(false);
        });
      }

      // if soundcastId is empty go to notfound
      if (isEmpty(soundcastID)) {
        return history.push('/notfound');
      }

      // retrieve soundcast
      const soundcast = await new Promise(async resolve => {
        const soundcast = await soundcastManager.getById(soundcastID);

        if (!isEmpty(soundcast) && !isEmpty(soundcast.title)) {
          console.log('From url param', soundcast);
          // set a default soundcast (free) price if not exist or empty
          if (isEmpty(soundcast.prices)) {
            soundcast.prices = [{ billingCycle: 'free', price: 'free', currency: 'USD' }];
          }
          return resolve({ ...soundcast });
        }

        resolve({});
      });

      // if soundcast not exist go to notfound
      if (isEmpty(soundcast)) {
        // console.log('From url param but not exist');
        return history.push('/notfound');
      }

      let selectedPlan = soundcast.prices[checked];
      if (isEmpty(selectedPlan)) {
        // throw new Error(`Price not exist for checked ${checked} TEST`);
        return this.setState({
          priceError: `Price not exist for checked ${checked}`,
        });
      }

      // if its private or not published, strictly no access
      const { published = false, landingPage: isPublic = false } = soundcast;
      const hasAccess = await new Promise(resolve => {
        if (!isPublic || !published) {
          return resolve(false);
        }

        resolve(true);
      });

      if (!hasAccess) {
        return history.push('/notfound');
      }

      // if the soundcast has custom payment
      // redirect to the specified payment form
      // before signup the user to soundcast
      if (hasCustomPaymentUrl(soundcast)) {
        return (window.location.href = soundcast.customPaymentUrl);
      }

      // from here on let's check user data
      authManager.onAuthStateChanged(async authUser => {
        const { uid: authUserId = '', email: authEmail = '' } = authUser || {};
        let userId = authUserId;
        let listenerInfo = {
          email: '',
          firstName: '',
          lastName: '',
        };
        let queryUserId = null;
        if (!isEmpty(queryEmail)) {
          try {
            const queryEmailLC = queryEmail.toLowerCase();
            queryUserId = await getUserIdByEmail(queryEmail);
            if (
              (!isEmpty(authEmail) && queryEmailLC !== authEmail.toLowerCase()) ||
              (!isEmpty(authUserId) && authUserId !== queryUserId)
            ) {
              if (this.isCorrectLocationPathname()) {
                await authManager.signOut();
                return window.location.reload();
              }
            }
  
            listenerInfo.email = queryEmailLC;
            userId = queryUserId;
          } catch (err) {
            console.error(`ERROR: ${err.message}`);
          }
        }
        if (!isEmpty(userId)) {
          const user = await userManager.getById(userId);
          if (!isEmpty(user)) {
            listenerInfo.firstName = user.firstName || '';
            listenerInfo.lastName = user.lastName || '';
            if (!isEmpty(user.email)) {
              listenerInfo.email = user.email[0] || '';
            }
          }
        }
        isNeedEmail = isEmpty(authUserId) && isEmpty(queryUserId);

        // handle coupon from here first
        selectedPlan = soundcast.prices[checked];
        if (isEmpty(selectedPlan)) {
          throw new Error(`Price not exist for checked ${checked}`);
        }
        let isFree = isFreePlan(selectedPlan);
        let isTrial = false;
        if (!isFree && !isEmpty(coupon)) {
          try {
            const { plan, isTrial: trial = false, isFree: free = false } = await makePlanFromCoupon(coupon, selectedPlan);
            selectedPlan = { ...plan };
            isTrial = trial;
            isFree = free;
          } catch (e) {}
        }

        const listenerDetails = isEmpty(customerDetails) ? {} : await new Promise(resolve => {
          const { email, name } = customerDetails || {};
          const [ firstName, lastName ] = (name || '').replace(/\s+/g, ' ').trim().split(' ');
          resolve({
            ...(isEmpty(email) ? {} : {
              email,
              emailReadOnly: true,
            }),
            ...(isEmpty(firstName) ? {} : { firstName }),
            ...(isEmpty(lastName) ? {} : { lastName }),
            isPaymentSignUp: true,
          });
        });

        // if a user isn't logged in
        // and its a free soundcast (isFree && !isTrial) or success payment (isConfirmed)
        // then force them to signup
        const historyState = { soundcastID, checked, sumTotal, coupon, listenerDetails };
        if (isEmpty(authUser) && ((isFree && !isTrial) || isConfirmed)) {
          // console.log('Going to /signup/soundcast_user');
          return history.push('/signup/soundcast_user', { ...historyState, indicator: false });
        }

        // if a user is logged in
        // or when a soundcast is forsale (logged in or not)
        // let's proceed to checkout page
        if (!isEmpty(authUser) || soundcast.forSale) {
          return this.setSoundcastData({
            listenerInfo,
            soundcast,
            soundcastID,
            checked,
            coupon,
            selectedPlan,
            isTrial,
            isFree,
            sessionId,
            isConfirmed,
            isNeedEmail,
            isMobileRequest,
          });
        }

        // otherwise make them login first
        return history.push('/signup/soundcast_user', { ...historyState, indicator: false });
      });
    } else {
      // if it goes here, none of the above conditions met
      // this page was access directly without the data needed
      // so make it redirect to notfound page
      return history.push('/notfound');
    }
  }

  async setSoundcastData(data) {
    const {
      listenerInfo, soundcast, soundcastID, checked, coupon, selectedPlan, isTrial,
      sessionId, isConfirmed, isNeedEmail, isMobileRequest,
    } = data;
    const { price: initialPrice } = soundcast.prices[checked];
    const { price: totalPrice } = selectedPlan;
    const isFree = isFreePlan(selectedPlan);

    // retrieve publisher
    const { publisherID } = soundcast;
    const publisher = await new Promise(async resolve => {
      try {
        const publisher = await publisherManager.getById(publisherID);

        if (isEmpty(publisher)) {
          throw new Error(`Publisher ${publisherID} no longer exist`);
        }

        resolve({
          id: publisherID,
          ...publisher,
        });
      } catch (err) {
        resolve({});
      }
    });

    this.setState(
      {
        listenerInfo,
        initialPrice,
        totalPrice,
        soundcast,
        soundcastID,
        publisher,
        coupon,
        checked,
        isFree,
        renderFields: true,
        sessionId,
        isConfirmed,
        ...(isConfirmed ? { charge: { success: true } } : {}),
        isNeedEmail,
        isMobileRequest,
      },
      () => {
        if (isConfirmed) {
          this.handlePaymentSuccess(this.state.charge);
        } else if (isFree && !isTrial) {
          // if this is free process immediately
          this.processPlanWithoutCharge();
        }
      }
    );
  }

  async processPlanWithoutCharge() {
    // TODO improve this part, its hack to wait for userinfo
    await new Promise(resolve => {
      const interval = setInterval(() => {
        if (has(this.props, 'userInfo.email')) {
          clearInterval(interval);
          resolve();
        }
      }, 500);
    });

    const { userInfo } = this.props;
    if (userInfo && !isEmpty(userInfo.email)) {
      addSoundcastToUser(
        null,
        userInfo,
        this.state.soundcastID,
        this.state.soundcast,
        this.state.checked,
        this.state.sumTotal,
        this.state.coupon,
        this.state.totalPrice,
        this.props.history
      );
    } else {
      // skip card input
      console.error('Unable to charge an unknown user');
      this.setState({ hideCardInputs: true });
    }
  }

  handleStripeId(charge, state) {
    // success payment callback
    // The app should check whether the email address of the user already has an account.
    // The stripe id associated with the user's credit card should be saved in user's data
    const { email, firstName, lastName } = state;
    authManager
      .fetchSignInMethodsForEmail(email)
      .then(providerInfo => {
        const newState = { successPayment: true, charge, email, firstName, lastName };
        // TODO add firstName, lastName, email validation
        // if user has an account, the providerInfo is either ['facebook.com'] or ['password']
        // if the user doesn't have account, the providerInfo returns empty array, []
        if (providerInfo && providerInfo.length) {
          // registered
          // If yes, app should sign in the user with the password entered or through FB;
          newState.runSignIn = true;
        }

        // If no, app should create a new account
        this.setState(newState);
      })
      .catch(err => {
        console.log('Payments fetchSignInMethodsForEmail', err);
      });
  }

  handleChange(field) {
    return e => {
      this.setState({ [field]: e.target.value });
    };
  }

  async handlePaymentSuccess(payment) {
    if (isEmpty(payment)) {
      return console.error(`ERROR: ${this.state.soundcastID} NOT SUPPORTED EMPTY PAYMENT`);
    }
    const { platformCustomer = null } = payment;
    await redirectToSoundcastNoticePage(
      this.state.soundcast,
      this.props.history,
      platformCustomer,
    );
  }

  handleAppliedPromo(promoCode) {
    return new Promise(async (resolve, reject) => {
      try {
        const { soundcastID, soundcast, checked, sumTotal } = this.state;
        const selectedPlan = soundcast.prices[checked];
        const { plan, isTrial, isFree, info } = await makePlanFromCoupon(promoCode, selectedPlan);
        this.setState(
          {
            totalPrice: plan.price,
            coupon: promoCode,
            isTrial,
            isFree,
          },
          () => {
            if (isFree && !isTrial) {
              // if they applied a promo and not loggedin
              // should redirect them to /signup/soundcast
              if (authManager.getCurrentUser()) {
                return this.processPlanWithoutCharge();
              }

              const historyState = { soundcastID, checked, sumTotal, coupon: promoCode };
              this.props.history.push('/signup/soundcast_user', {
                ...historyState,
                indicator: false,
              });
            }
          }
        );

        resolve({
          price: plan.price,
          promoCodeInfo: info,
        });
      } catch (e) {
        reject(e);
      }
    });
  }

  authCallback(user, type = 'signin') {
    this.props[`${type}User`](user);

    this.handlePaymentSuccess(this.state.charge);
  }

  submitPassword() {
    this.setState({ error: false, processing: true, dirty: false }, async () => {
      try {
        const { runSignIn, email, password } = this.state;
        if (runSignIn) {
          const user = await signInPassword(email, password);
          return this.authCallback(user, 'signin');
        }

        const resultUser = await signupCommon(this.state, { isListenerDirectSignup: true });
        this.authCallback(resultUser, 'signup');
      } catch (error) {
        this.setState({ error: error.message, processing: false, dirty: true });
      }
    });
  }

  renderPublisherLogo() {
    const { publisher } = this.state;
    if (isEmpty(publisher)) return null;

    const { id: publisherId, name, imageUrl } = publisher;
    return (
      <a href={`${STATIC_HOMEPAGE_URL}/publishers/${publisherId}`} title={name} target="_blank">
        <PublisherLogoWrapper
          className="xs-padding-three-left"
          alignItems="center"
          flexWrap="nowrap">
          <img className="border-radius-50 logo" alt={name} src={imageUrl} />
          <span className="publisher-name margin-one-left xs-margin-five-left text-large">
            {name}
          </span>
        </PublisherLogoWrapper>
      </a>
    );
  }

  renderAuthScreen() {
    const { error, successPayment, runSignIn, password, processing, dirty } = this.state;

    if (!successPayment) {
      return null;
    }

    const passwordPlaceholder = runSignIn ? 'Enter your password' : 'Create your password';
    const passwordBtnText = runSignIn ? 'SIGN IN' : 'CREATE';
    const minPasswordLength = runSignIn ? 1 : 6;
    const submitDisabled = !password || password.length < minPasswordLength;

    return (
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 sm-no-margin text-center">
          <div className="margin-fifteen-top">
            <div className="auth-title title-large font-weight-600">Final step</div>
            {runSignIn && (
              <span className="text-extra-medium">Sign in to your Soundwise account</span>
            )}
            <div className="text-medium padding-five">{passwordPlaceholder}</div>
            {error && <div className="text-medium text-red padding-two-bottom">{error}</div>}
            <GreyInput
              type="password"
              styles={{ width: 270 }}
              placeholder={'Password'}
              onChange={this.handleChange('password')}
              value={password}
              validators={[minLengthValidator.bind(null, minPasswordLength)]}
            />
            <SubmitButton
              disabled={submitDisabled}
              loading={processing}
              onSignIn={this.submitPassword}
              label={passwordBtnText}
            />
            <BeforeUnload dirty={dirty} message="Please login to complete your subscription." />
          </div>
        </div>
      </div>
    );
  }

  renderBody() {
    const {
      listenerInfo,
      soundcast,
      publisher,
      soundcastID,
      checked,
      initialPrice,
      totalPrice,
      isTrial,
      isFree,
      coupon,
      hideCardInputs,
      successPayment,
      renderFields,
      sessionId,
      isNeedEmail,
      isMobileRequest,
      isConfirmed = false,
      error,
      priceError,
    } = this.state;
    const { userInfo } = this.props;

    if (!isEmpty(priceError)) {
      const locationUrlWithOutChecked = () => {
        const hrefUrl = new URL(window.location.href);
        hrefUrl.searchParams.delete('checked');
        const { pathname = '', search = '' } = new URL(hrefUrl.toString());
        window.location.href = (pathname + search) || '';
      };
      return (
        <LoadingWrapper height="auto">
          <div className="alert alert-danger padding-nine text-large" role="alert">
            {priceError}<br/>
            Using default price?<br/>
            <SubmitButton
              onSignIn={() => { locationUrlWithOutChecked(); }}
              label=">>>"
            />
          </div>
        </LoadingWrapper>
      );
    }

    if ((isEmpty(soundcast) && isEmpty(publisher)) || isConfirmed) {
      return (
        <LoadingWrapper height="auto">
          <Loading text="Loading Audio Program" align="center" size={50} fontSize={1.6} />
        </LoadingWrapper>
      );
    }

    const inCartProps = !successPayment
      ? {
          coupon,
          soundcast,
          checked,
          isFree,
          isTrial,
          initialPrice,
          onAppliedPromo: this.handleAppliedPromo,
        }
      : {
          soundcast,
          successPayment: true,
        };
    // console.log('In cart props', inCartProps);

    return (
      <CheckoutWrapper>
        <div className="row">
          <div className="col-lg-4 col-md-8 col-sm-12 center-col">
            <CheckoutBody className="padding-nine sm-padding-ten margin-lr-auto">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 sm-no-margin">
                  <SoundcastInCart {...inCartProps} />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                  {!successPayment && renderFields && (
                    <Payment2
                      listenerInfo={listenerInfo}
                      userInfo={userInfo}
                      soundcastID={soundcastID}
                      soundcast={soundcast}
                      publisher={publisher}
                      checked={checked}
                      coupon={coupon}
                      totalPrice={totalPrice}
                      isTrial={isTrial}
                      isFree={isFree}
                      hideCardInputs={hideCardInputs}
                      isNeedEmail={isNeedEmail}
                      isMobileRequest={isMobileRequest}
                      sessionId={sessionId}
                      error={error}
                      handleStripeId={this.handleStripeId}
                      onPaymentSuccess={this.handlePaymentSuccess}
                    />
                  )}
                  {this.renderAuthScreen()}
                </div>
              </div>
            </CheckoutBody>
          </div>
        </div>
      </CheckoutWrapper>
    );
  }

  render() {
    return (
      <FullContentWrapper>
        <SoundwiseHeader showIcon={false} customIcon={this.renderPublisherLogo()} />
        <FullContentSection background="#fafafa">{this.renderBody()}</FullContentSection>
      </FullContentWrapper>
    );
  }
}

const PublisherLogoWrapper = styled(FlexiRow)`
  .logo {
    width: 50px;
    height: 50px;
    object-fit: cover;

    @media (max-width: 991px) {
      max-height: 40px;
      max-width: 40px;
    }
  }

  .publisher-name {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    min-width: 0;
  }
`;

const mapStateToProps = state => {
  const { userInfo } = state.user;
  return { userInfo };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ signinUser, signupUser }, dispatch);
}

const Checkout_worouter2 = connect(mapStateToProps, mapDispatchToProps)(_SoundcastCheckout2);

export const SoundcastCheckout2 = withRouter(Checkout_worouter2);
